export default class CommentPresenter {
    constructor (mentionRender) {
        this.mentionRender = mentionRender
    }

    present (comments = []) {
        const presented = {}

        comments.sort((a, b) => {
            return a.created_at > b.created_at ? 1 : -1
        })

        for (let comment of comments) {
            if (presented[comment.chunk_key] === undefined) {
                presented[comment.chunk_key] = []
            }

            let chunk = this.findOrCreateChunk(presented, comment)

            chunk.comments.push(this.presentComment(comment))
        }

        return presented
    }

    presentComment (comment) {
        if (comment.message) {
            comment.message = this.mentionRender.replaceMentions(comment.message)
            comment.message = this.replaceEmojis(comment.message)
        }

        return comment
    }

    replaceEmojis (message) {
        const emojis = message.match(/(:[a-z0-9-_+]+(?:::skin-tone-[2-6])?:)/gs)

        if (emojis) {
            emojis.forEach((emoji) => {
                message = this.replaceSingleEmoji(message, emoji)
            })
        }

        return message
    }

    replaceSingleEmoji (message, emojiCode) {
        if (this.emojiResolver) {
            return message.replace(emojiCode, this.emojiResolver(emojiCode))
        }

        return message
    }

    setEmojiResolver (callback) {
        this.emojiResolver = callback
    }

    findOrCreateChunk (presented, comment) {
        let newChunk = {
            message: comment.type === 'message',
            author: comment.author,
            comments: []
        }

        let lastChunk = this.lastChunkByTimestamp(presented, comment.chunk_key)

        if (presented[comment.chunk_key].length === 0 || lastChunk.author.id !== newChunk.author.id || lastChunk.message !== newChunk.message) {
            presented[comment.chunk_key].push(newChunk)

            return newChunk
        }

        return lastChunk
    }

    lastChunkByTimestamp (presented, key) {
        return presented[key][presented[key].length - 1]
    }
}
